import { Headers } from 'src/components/shared/ui/table/types';

export const absenceHeadersEmp: Headers[] = [
  { header: 'Motivo', key: 'motive' },
  { header: 'Inicio', key: 'startDate' },
  { header: 'Fin', key: 'endDate' },
  { header: 'Estado', key: 'state' },
  { header: 'Acción', key: 'icon' },
];
